import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import { CircleHelp } from '@lucide/vue';
import {
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from 'reka-ui';


export default /*@__PURE__*/_defineComponent({
  __name: 'Hint',
  props: {
    label: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TooltipProvider), { "delay-duration": 200 }, {
    default: _withCtx(() => [
      _createVNode(_unref(TooltipRoot), null, {
        default: _withCtx(() => [
          _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "hint-trigger",
                "aria-label": __props.label
              }, [
                _createVNode(_unref(CircleHelp), { size: 14 })
              ], 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_unref(TooltipPortal), null, {
            default: _withCtx(() => [
              _createVNode(_unref(TooltipContent), {
                side: "top",
                "side-offset": 6,
                class: "hint-bubble"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})